import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';

const PromoModal = ({ mode, promo, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    discount: 0,
    status: true
  });
  
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (mode === 'edit' && promo) {
      setFormData({
        name: promo.name || '',
        description: promo.description || '',
        discount: promo.discount || 0,
        status: promo.status !== undefined ? promo.status : true
      });
    }
  }, [mode, promo]);

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    
    if (!formData.description.trim()) {
      newErrors.description = 'Description is required';
    }
    
    if (formData.discount === '' || isNaN(formData.discount)) {
      newErrors.discount = 'Discount must be a number';
    } else if (Number(formData.discount) < 0) {
      newErrors.discount = 'Discount must be more than 0';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // Convert discount to number before submitting
      const submissionData = {
        ...formData,
        discount: Number(formData.discount)
      };
      
      onSubmit(submissionData);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg text-black">
        <div className="flex items-center justify-between bg-gray-100 p-4 rounded-t-lg">
          <h2 className="text-xl font-bold">
            {mode === 'create' ? 'Create New Promo Code' : 'Edit Promo Code'}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <FiX size={24} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6">
        
<div className="mb-4">
  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
    Promo Name
  </label>
  <input
    id="name"
    name="name"
    type="text"
    value={formData.name}
    onChange={(e) => {
      // Transform input to uppercase before setting the state
      const uppercaseValue = e.target.value.toUpperCase();
      // Create a new event object with the modified value
      const modifiedEvent = {
        ...e,
        target: {
          ...e.target,
          value: uppercaseValue,
          name: e.target.name
        }
      };
      handleChange(modifiedEvent);
    }}
    className={`shadow appearance-none border ${
      errors.name ? 'border-red-500' : 'border-gray-300'
    } rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
    placeholder="ENTER PROMO CODE (UPPERCASE ONLY)"
    style={{ textTransform: 'uppercase' }}
    autoCapitalize="characters"
  />
  {errors.name && (
    <p className="text-red-500 text-xs italic mt-1">{errors.name}</p>
  )}
  <p className="text-gray-500 text-xs mt-1">Promo codes must be in UPPERCASE</p>
</div>
          
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="description">
              Description
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="3"
              className={`shadow appearance-none border ${
                errors.description ? 'border-red-500' : 'border-gray-300'
              } rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
              placeholder="Enter promo description"
            />
            {errors.description && (
              <p className="text-red-500 text-xs italic mt-1">{errors.description}</p>
            )}
          </div>
          
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="discount">
              Discount(₹)
            </label>
            <input
              id="discount"
              name="discount"
              type="number"
              min="0"
              value={formData.discount}
              onChange={handleChange}
              className={`shadow appearance-none border ${
                errors.discount ? 'border-red-500' : 'border-gray-300'
              } rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
              placeholder="Enter discount percentage"
            />
            {errors.discount && (
              <p className="text-red-500 text-xs italic mt-1">{errors.discount}</p>
            )}
          </div>
          
          <div className="mb-6">
            <label className="flex items-center">
              <input
                type="checkbox"
                name="status"
                checked={formData.status}
                onChange={handleChange}
                className="mr-2 leading-tight"
              />
              <span className="text-sm font-medium text-gray-700">Active</span>
            </label>
          </div>
          
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded mr-2 focus:outline-none focus:shadow-outline"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              {mode === 'create' ? 'Create' : 'Update'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PromoModal;